module.exports = __webpack_public_path__ + "media/images/close-button-e3a23f97792f3cea1b15fbce2e680b18.svg";